import { useState } from 'react';
import { resetPassword, confirmResetPassword } from 'aws-amplify/auth';
import { Link, useNavigate } from 'react-router-dom'; // import useNavigate from react-router-dom
import '../Mfa/mfaVerification.css'; // Reuse MFA styles
import GlueLogo from '../glueLogo';

const ForgotPassword = () => {
    const [step, setStep] = useState(1); // 1: email, 2: code + new password
    const [email, setEmail] = useState('');
    const [code, setCode] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const navigate = useNavigate(); // Initialize navigate hook

    const handleEmailSubmit = async () => {
        if (!email) {
            setError('Please enter your email address.');
            return;
        }

        try {
            await resetPassword({ username: email });
            setStep(2);
            setError('');
        } catch (err) {
            console.error('Reset error:', err);
            setError('Failed to send reset code. Please check your email.');
        }
    };

    const handleResetConfirm = async () => {
        if (!code || !newPassword) {
            setError('Please enter code and new password.');
            return;
        }

        try {
            await confirmResetPassword({ username: email, confirmationCode: code, newPassword });
            setMessage('Password has been reset successfully.');
            setError('');
            setStep(1);
            setEmail('');
            setCode('');
            setNewPassword('');
        } catch (err) {
            console.error('Confirm reset error:', err);
            setError('Invalid code or password. Try again.');
        }
    };

    const goToHome = () => {
        navigate('/'); // Redirect to the home page
    };

    return (
        <div className="mfa-container">
            <div className="mfa-box">
                <h2 className="mfa-subtitle">
                    <Link to="/" style={{ textDecoration: 'none' }}><GlueLogo height="50" /></Link>
                </h2>
                <h1 className="mfa-title">Forgot Your Password?</h1>

                {step === 1 ? (
                    <>
                        <p className="mfa-desc">Enter your registered email to receive a reset code.</p>
                        <input
                            type="email"
                            placeholder="Email address"
                            className="mfa-input"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <button className="mfa-button" onClick={handleEmailSubmit}>
                            Send Reset Code
                        </button>
                    </>
                ) : (
                    <>
                        <p className="mfa-desc">Enter the code sent to your email and your new password.</p>
                        <input
                            type="text"
                            placeholder="Verification code"
                            className="mfa-input"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                        />
                        <input
                            type="password"
                            placeholder="New password"
                            className="mfa-input"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                        />
                        <p className="password-policy">Password policy</p>
                        <ul className='password-policy'>
                            <li>Use atleast one One Uppercase Letter</li>
                            <li>Use atleast one One Lowercase Letter</li>
                            <li>Use atleast one Number</li>
                            <li>Use any Special Character (!@#$%^&*)</li>
                        </ul>
                        <button className="mfa-button" onClick={handleResetConfirm}>
                            Reset Password
                        </button>
                    </>
                )}

                {error && <div className="mfa-error">{error}</div>}
                {message && (
                    <div className="mfa-success">
                        {message}
                        <button className="mfa-button" onClick={goToHome}>Go to Home</button> {/* Go to Home button */}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ForgotPassword;
